'use client';

import clsx from 'clsx';
import { useLayoutEffect, useState } from 'react';

import ArrowNext from '@/components/shared/Icon/ArrowNext';
import cn from '@/helpers/cn';
import { gsap, ScrollSmoother } from '@/lib/gsap';

import css from './style.module.scss';

const ToTopButton = () => {
	const [isShow, setIsShow] = useState(false);

	useLayoutEffect(() => {
		const ctx = gsap.context(() => {
			const onScroll = () => {
				if (window.scrollY > window.innerHeight * 2) setIsShow(true);
				else setIsShow(false);
			};

			window.addEventListener('scroll', onScroll);

			return () => {
				window.removeEventListener('scroll', onScroll);
			};
		});

		return () => ctx.revert();
	}, []);

	const scrollToTop = () => {
		const smoother = ScrollSmoother.get();

		if (smoother)
			gsap.to(smoother, {
				scrollTop: 0,
				duration: 1.5,
				ease: 'power2.out'
			});
		else window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<button
			type="button"
			className={clsx(css.wrapper, isShow ? css.isShow : css.isHidden)}
			onClick={scrollToTop}
		>
			<ArrowNext className={cn(css.arrow, css.arrowFirst)} />
			<ArrowNext className={cn(css.arrow, css.arrowSecond)} />
		</button>
	);
};

export default ToTopButton;
